import Vue from 'vue';
import loadingVue from './loading.vue';
import { addClass, removeClass, getStyle } from '../../../utils/dom';
import { PopupManager } from 'element-ui/lib/utils/popup';
import afterLeave from '../../../utils/after-leave';
import merge from '../../../utils/merge';

const LoadingConstructor = Vue.extend(loadingVue);

const defaults = {
  text: null
};

LoadingConstructor.prototype.originalPosition = '';
LoadingConstructor.prototype.originalOverflow = '';

LoadingConstructor.prototype.close = function () {
  afterLeave(
    this,
    _ => {
      const target = this.fullscreen || this.body ? document.body : this.target;
      removeClass(target, 'rt-loading-parent--relative');
      removeClass(target, 'rt-loading-parent--hidden');
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
      this.$destroy();
    },
    300
  );
  this.visible = false;
};

const addStyle = (options, parent, instance) => {
  let maskStyle = {};
  if (options.body) {
    instance.originalPosition = getStyle(document.body, 'position');
    ['top', 'left'].forEach(property => {
      let scroll = property === 'top' ? 'scrollTop' : 'scrollLeft';
      maskStyle[property] =
        options.target.getBoundingClientRect()[property] +
        document.body[scroll] +
        document.documentElement[scroll] +
        'px';
    });
    ['height', 'width'].forEach(property => {
      maskStyle[property] = options.target.getBoundingClientRect()[property] + 'px';
    });
    if (options.fullscreen) {
      instance.originalOverflow = getStyle(document.body, 'overflow');
      maskStyle.zIndex = PopupManager.nextZIndex();
    }
  } else {
    instance.originalPosition = getStyle(parent, 'position');
  }
  Object.keys(maskStyle).forEach(property => {
    instance.$el.style[property] = maskStyle[property];
  });
};

const Loading = (options = {}) => {
  options = merge({}, defaults, options);
  if (typeof options.target === 'string') {
    options.target = document.querySelector(options.target);
  }
  options.target = options.target || document.body;
  if (options.target !== document.body) {
    //
  } else {
    options.body = true;
  }

  let parent = options.body ? document.body : options.target;
  let instance = new LoadingConstructor({
    el: document.createElement('div'),
    data: options
  });

  addStyle(options, parent, instance);
  if (instance.originalPosition !== 'absolute' && instance.originalPosition !== 'fixed') {
    addClass(parent, 'rt-loading-parent--relative');
  }
  addClass(parent, 'rt-loading-parent--hidden');
  parent.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.visible = true;
  });
  return instance;
};

export default Loading;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/loading/src/index.js